<script>
    import { navigate } from "svelte-routing";
    export let target;

    if (window.location.hash.includes("register")) {
        target = "/register";
    }

    navigate(target);
</script>